import { Box } from "@mui/material";
import IntroPageBackground from "../../images/header-background.WEBP";
import SarodiIcon from "../../images/sarodi-white.svg";

const IntroPage = () => {
  return (
    <Box>
      <Box
        sx={{
          position: "absolute",
          top: "15%",
          right: "20%",
          width: { xs: "15rem" },
        }}
      >
        <img width="100%" height="100%" src={SarodiIcon} alt="Sarodi icon" />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "0",
          right: "20%",
          height: "14dvh",
          width: "2px",
          background: "#cd7466",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "25%",
          right: "20%",
          height: { lg: "30dvh", xl: "29dvh" },
          width: "2px",
          background: "#cd7466",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          zIndex: "-1",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          src={IntroPageBackground}
          alt="Background for introducing Sarodi"
        />
      </Box>
    </Box>
  );
};

export default IntroPage;
